import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  selectIsLoggedIn,
  loggedInUser,
  logout,
} from "../redux/slice/authSlice";
import { message } from "antd";
import { persistor } from "../redux/store";
const SessionExpiryHandler = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const userData = useSelector(loggedInUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const checkSessionExpiry = () => {
      if (isLoggedIn && userData?.expireTime) {
        if (Date.now() > userData.expireTime) {
          dispatch(logout());
          message.warning("Your session has expired. Please log in again.");
          navigate("/Login");
        }
      }
    };
    if (isLoggedIn) {
      const interval = setInterval(checkSessionExpiry, 60000);

      return () => clearInterval(interval);
    } else {
      dispatch(logout());
      navigate("/Login");
    }
  }, [isLoggedIn]);

  return null;
};

export default SessionExpiryHandler;
